/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Kiotviet_Sync_NowInputs */

const vi_customer_kiotviet_sync_now = /** @type {(inputs: Customer_Kiotviet_Sync_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đồng bộ KiotViet`)
};

/**

* @param {Customer_Kiotviet_Sync_NowInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_kiotviet_sync_now = /** @type {((inputs?: Customer_Kiotviet_Sync_NowInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Kiotviet_Sync_NowInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_kiotviet_sync_now(inputs)
});